import { useMutationHook, useQueryHook } from "@/hooks"
import {
  readSpeedZones,
  readAccelZones,
  readDecelZones,
  readHrZones,
  readPlayerCustomMetricHistory,
  upsertAccelZones,
  upsertDecelZones,
  upsertHrZones,
  upsertPlayerMetricAccelActive,
  upsertPlayerMetricDecelActive,
  upsertPlayerMetricHrActive,
  upsertPlayerMetricSpeedActive,
  upsertSpeedZones,
} from "@/app/api/zone"
import {
  ReadPlayerCustomMetricHistoryParams,
  ReadPlayerCustomMetricHistoryResponse,
  ReadSpeedZonesResponse,
} from "@/types/zone"
import { UseQueryOptions } from "@tanstack/react-query"
import { ApiError } from "@/app/api/type"

export const useSpeedZonesQuery = ({ enabled }: { enabled: boolean }) => {
  return useQueryHook({
    queryKey: ["readSpeedZones"],
    queryFn: readSpeedZones,
    options: { enabled } as UseQueryOptions<ReadSpeedZonesResponse, ApiError>,
  })
}
export const useAccelZonesQuery = ({ enabled }: { enabled: boolean }) => {
  return useQueryHook({
    queryKey: ["readAccelZones"],
    queryFn: readAccelZones,
    options: { enabled } as UseQueryOptions<ReadSpeedZonesResponse, ApiError>,
  })
}
export const useDecelZonesQuery = ({ enabled }: { enabled: boolean }) => {
  return useQueryHook({
    queryKey: ["readDecelZones"],
    queryFn: readDecelZones,
    options: { enabled } as UseQueryOptions<ReadSpeedZonesResponse, ApiError>,
  })
}
export const useHrZonesQuery = () => {
  return useQueryHook({ queryKey: ["readHrZones"], queryFn: readHrZones })
}
export const usePlayerCustomMetricHistoryQuery = (params: ReadPlayerCustomMetricHistoryParams) => {
  return useQueryHook({
    queryKey: ["readPlayerCustomMetricHistory", params.idfPlayer, params.metric],
    queryFn: () => readPlayerCustomMetricHistory(params),
    options: { enabled: params.idfPlayer !== null } as UseQueryOptions<
      ReadPlayerCustomMetricHistoryResponse,
      ApiError
    >,
  })
}

export const useUpsertSpeedZonesMutation = () => {
  return useMutationHook(upsertSpeedZones, ["readSpeedZones"])
}
export const useUpsertPlayerMetricSpeedActiveMutation = () => {
  return useMutationHook(upsertPlayerMetricSpeedActive, ["readSpeedZones"])
}

export const useUpsertAccelZonesMutation = () => {
  return useMutationHook(upsertAccelZones, ["readAccelZones"])
}
export const useUpsertPlayerMetricAccelActiveMutation = () => {
  return useMutationHook(upsertPlayerMetricAccelActive, ["readAccelZones"])
}

export const useUpsertDecelZonesMutation = () => {
  return useMutationHook(upsertDecelZones, ["readDecelZones"])
}
export const useUpsertPlayerMetricDecelActiveMutation = () => {
  return useMutationHook(upsertPlayerMetricDecelActive, ["readDecelZones"])
}

export const useUpsertHrZonesMutation = () => {
  return useMutationHook(upsertHrZones, ["readHrZones"])
}
export const useUpsertPlayerMetricHrActiveMutation = () => {
  return useMutationHook(upsertPlayerMetricHrActive, ["readHrZones"])
}
